export enum ImageSrcSetEnum {
  Big = 'big',
  Medium = 'medium',
  Mobile = 'mobile',
  Card = 'card',
}
